import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getToolLandingConfig } from '../lib/toolLandingConfigs';
import ServicePage from './ServicePage';
import DocumentToolLandingPage from './DocumentToolLandingPage';

const UTILITY_SLUGS = ['pdf-compression', 'visa-passport-photo'];

export default function ServiceLandingRoute() {
  const { serviceType } = useParams();

  if (UTILITY_SLUGS.includes(serviceType)) {
    return <ServicePage />;
  }

  if (getToolLandingConfig(serviceType) && !getToolLandingConfig(serviceType).isUtility) {
    return <DocumentToolLandingPage />;
  }

  return <Navigate to="/" replace />;
}
